module.exports = __webpack_public_path__ + "static/media/close-line.c748de6b.svg";